import ConnectSDK from './ConnectSDK';
import { IConnectSDK } from './types';
export * from './types/index';

const connectSingleton = new ConnectSDK();

export const paragon: IConnectSDK = {
  authenticate: connectSingleton.authenticate.bind(connectSingleton),
  connect: connectSingleton.connect.bind(connectSingleton),
  event: connectSingleton.event.bind(connectSingleton),
  getIntegrationMetadata: connectSingleton.getIntegrationMetadata.bind(connectSingleton),
  getUser: connectSingleton.getUser.bind(connectSingleton),
  request: connectSingleton.request.bind(connectSingleton),
  subscribe: connectSingleton.subscribe.bind(connectSingleton),
  unsubscribe: connectSingleton.unsubscribe.bind(connectSingleton),
  workflow: connectSingleton.workflow.bind(connectSingleton),
  _oauthCallback: connectSingleton._oauthCallback.bind(connectSingleton),
  _oauthErrorCallback: connectSingleton._oauthErrorCallback.bind(connectSingleton),
  installIntegration: connectSingleton.installIntegration.bind(connectSingleton),
  uninstallIntegration: connectSingleton.uninstallIntegration.bind(connectSingleton),
  disableWorkflow: connectSingleton.disableWorkflow.bind(connectSingleton),
  setUserMetadata: connectSingleton.setUserMetadata.bind(connectSingleton),
  configureGlobal: connectSingleton.configureGlobal.bind(connectSingleton),
};

export default { ConnectSDK };
